import React from 'react';
import Icon from '../../../components/openplay/OpenPlayIcon';
import AppImage from '../../../components/openplay/OpenPlayImage';

const ApplicationCard = ({ application }) => {
  return (
    <div className="bg-card rounded-xl border border-border p-4 shadow-elevation-1 hover:shadow-elevation-2 transition-smooth">
      <div className="flex items-start gap-3 mb-3">
        <div className="relative w-12 h-12 rounded-full overflow-hidden bg-muted flex-shrink-0">
          <AppImage src={application.applicantAvatar} alt={application.applicantAvatarAlt} className="w-full h-full object-cover" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h3 className="text-base font-semibold text-foreground">{application.applicantName}</h3>
            <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-accent/10 text-accent">
              {application.skillLevel}
            </span>
          </div>
          <p className="text-sm text-muted-foreground caption">{application.eventTitle}</p>
          <p className="text-xs text-muted-foreground mt-1">{application.appliedDate}</p>
        </div>
      </div>

      {application.message && (
        <div className="bg-muted rounded-lg p-3 mb-3">
          <p className="text-sm text-foreground">{application.message}</p>
        </div>
      )}

      <div className="flex gap-2">
        <button
          className="flex-1 flex items-center justify-center gap-2 px-4 py-2 rounded-lg bg-primary text-primary-foreground hover:shadow-elevation-2 transition-smooth touch-target font-medium active:scale-97"
          type="button"
        >
          <Icon name="CheckIcon" size={16} />
          <span>승인</span>
        </button>
        <button
          className="flex-1 flex items-center justify-center gap-2 px-4 py-2 rounded-lg border border-border text-foreground hover:bg-muted transition-smooth touch-target font-medium"
          type="button"
        >
          <Icon name="XMarkIcon" size={16} />
          <span>거절</span>
        </button>
        <button
          className="flex items-center justify-center px-3 py-2 rounded-lg border border-border text-foreground hover:bg-muted transition-smooth touch-target"
          type="button"
        >
          <Icon name="ChatBubbleLeftIcon" size={16} />
        </button>
      </div>
    </div>
  );
};

export default ApplicationCard;
